module.exports = __webpack_public_path__ + "static/media/dipojokbaca.8883ac9c.jpg";